import React from 'react';
import WordCounter from './WordCounter';

function App() {
  return (
    <div className="App">
      <h1>Responsive Word Counter</h1>
      <WordCounter />
    </div>
  );
}

export default App;

